import styled from 'styled-components';

const ButtonBase = styled.button`
    background-color: #fff;
    display: inline-block;
    text-transform: uppercase;
    text-align: center;
    font-size: 14px;
    box-shadow: 0 1px 2px 0 rgba(0,0,0,0.30);
    border-radius: 2px;
    border: 0px;
    margin: 0px;
    pointer-events: ${props => (props.disabled ? 'none' : 'auto')};

    &[disabled] {
        opacity: 0.5;
        cursor: default;
    };

    &:focus {outline:0;};

    &:hover {
        box-shadow: 0 2px 4px 0 rgba(0,0,0,0.40);
    }`;
export default ButtonBase;



// WEBPACK FOOTER //
// ./src/components/atoms/buttons/base/Base.js